import {Card, Flex, Spin, Typography} from "antd";
import {Page} from "./pages/login/ui/Page";
import styled from "@emotion/styled";
import {LinkLogin, MagicLinkLoginStore} from "./hooks/useMagicLoginPageAction";
import {CloseOutlined} from "@ant-design/icons";
// import {t} from 'i18n-js'
import {useTranslation} from "react-i18next";

export const CloseButton = styled(CloseOutlined)`
  opacity: 0.5;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`


const TitleContent = styled(Flex)`
  gap: 10px;
  align-items: center;
  justify-content: center;
`

const StyledSpin = styled(Spin)`

`

const CentredText = styled(Typography.Text)`
  text-align: center;
  font-size: 1.1rem;
`

const StyledPage = styled(Page)`
  position: absolute;
  z-index: 999999;
  padding: 20px !important;
  transform-box: border-box;
`

const StyledCard = styled(Card)`
  max-width: 500px;
  width: 100%;
`

const TitleText = styled(Typography.Paragraph)`
  font-size: 1.1rem;
  width: 100%;
  margin: 0;
  padding: 0;
  padding-top: 15px;
  white-space: pre-wrap;
`


export const LinkExpired = () => {
    return (
        <CentredText type="danger">
            The link has expired. Please request a new one.
        </CentredText>
    )
}

export const authTranslations = {
    'en': {
        'authorization': 'Authorization',
        'please-wait': 'Please wait...',
    },
    'fi': {
        'authorization': 'Valtuutus',
        'please-wait': 'Odota hetki...'
    }
}


export const MagicLink = () => {
    const {t} = useTranslation(['auth']);
    LinkLogin.useLoginLoadEffect();
    const s = MagicLinkLoginStore.useState();
    return (
        <StyledPage>
            <StyledCard title={
                <TitleContent>
                    {s.loading && <StyledSpin/>}
                    <Flex style={{
                        width: '100%'
                    }} justify={"space-between"}>
                        <TitleText>{t('authorization')}</TitleText>
                        <CloseButton onClick={() => {
                            window.location.href = '/'
                        }}/>
                    </Flex>

                </TitleContent>

            }>
                {
                    s.loading ? (
                        <CentredText>
                            {t('please-wait')}
                        </CentredText>
                    ) : null
                }

                {
                    s.error ? (
                        <LinkExpired/>
                    ) : null
                }
            </StyledCard>
        </StyledPage>

    )
}
